import React from 'react';
import styled from 'styled-components';

const StyledSVG = styled.svg`
    vertical-align: middle;
    font-size: 0;
`;

const SvgIcon = ({ className, svg, ...props }) => {
    const names = ['icon'];
    if(className != null) {
        names.push(className);
    }

    return (
        <StyledSVG { ...props } className={ names.join(' ') }>
            <use xlinkHref={ '#' + svg } />
        </StyledSVG>
    );
};

export default styled(SvgIcon)``;